export const TELEFONE_PATTERN = '(99) 99999-9999';

export const CPF_PATTERN = '999.999.999-99';

export const CNPJ_PATTERN = '99.999.999/9999-99';

export const CEP_PATTERN = '99.999-999';

export const RG_PATTERN = '99.999.999-9';

export const CREDIT_CARD = '9999 9999 9999 9999';

export const DATA_VENCIMENTO_CARTAO = '99/99';

export const CVC_PATTERN = ['999', '9999'];
